import { render, staticRenderFns } from "./produce-selector.vue?vue&type=template&id=981ad10a&scoped=true&"
import script from "./produce-selector.vue?vue&type=script&lang=ts&"
export * from "./produce-selector.vue?vue&type=script&lang=ts&"
import style0 from "./produce-selector.vue?vue&type=style&index=0&id=981ad10a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981ad10a",
  null
  
)

export default component.exports